import { IIceConfig } from '@/helpers/user';
import HttpHelper from '@/helpers/http';

interface IFontResponse {
  success?: boolean;
  fonts?: any;
}

export default class EditorApi {
  static async getFonts(): Promise<IFontResponse> {
    return await HttpHelper.get('/api/v1/fonts', { background: true });
  }

  static async checkPreview(url: string): Promise<{ previewAvailable: boolean, success: boolean; }> {
    return await HttpHelper.get(url, { background: true });
  }

  static async requestPreview(url: string): Promise<{ success: boolean; }> {
    return await HttpHelper.post(url, null, { background: true });
  }

  static async goLive(url: string): Promise<{ success: boolean; }> {
    return await HttpHelper.post(url, null, { background: true });
  }
}
